import React from 'react';
import { string } from 'prop-types';
import { SellerLevelOneBadge, SellerLevelTwoBadge, TopRatedBadge } from '@fiverr-private/badges';

const MAP_SELLER_LEVEL_TO_BADGE = {
    LEVEL_TRS: TopRatedBadge,
    LEVEL_ONE: SellerLevelOneBadge,
    LEVEL_TWO: SellerLevelTwoBadge,
};

export const Badge = ({ sellerLevel }) => {
    const LevelBadge = MAP_SELLER_LEVEL_TO_BADGE[sellerLevel];

    if (LevelBadge) {
        return <LevelBadge />;
    }

    return <div style={{ height: '20px' }} />;
};

Badge.propTypes = {
    sellerLevel: string,
};
